import React, { useEffect, useMemo, useState } from 'react';
const RotatingTextSlider = ({ eventData, landingPageData }: { eventData: any; landingPageData: any }) => {

  const exhibitorsCount     = eventData?.exhibitor_count;
  const participantsCount   = eventData?.participant_count;
  const speakersCount       = eventData?.speaker_count;
  const sessionCount        = eventData.sessionsCount ? eventData.sessionsCount : 0;
  const [index, setIndex] = useState(0);

 

  const rotatingTexts = useMemo(() => {
    return [
      { count: speakersCount, label: 'Speakers' },
      { count: participantsCount, label: 'Participants' },
      { count: exhibitorsCount, label: 'Exhibitors' },
      { count: sessionCount, label: 'Sessions' }
    ];
  }, [speakersCount, participantsCount, exhibitorsCount, eventData.sessionsCount]);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % rotatingTexts.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [rotatingTexts]);

  return (
    <span className="cd-words-wrapper">
      {rotatingTexts.map((item, i) => (
        item.count > 0 && (
          <b
            key={i}
            className={i === index ? 'is-visible' : 'is-hidden'}
            style={{ transition: 'opacity 0.5s' }}
          >
             <i style={{ color: eventData?.primary_color }}>{item.count}</i>
            <span style={{ color: eventData?.primary_text_color,display: "inline",fontSize: "45px", padding:"0.5em" }}>
              {item.label}
            </span>
            
          </b>
        )
      ))}
    </span>
  );
};

export default RotatingTextSlider;
